import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';
import { style } from '../../../components/pdf/fontstyles';


const styles = StyleSheet.create({
  page: {
    padding: 40,
    marginLeft: 20,
    fontSize: 12,
    lineHeight: 1.5,
    ...style.marathi,
  },
  header: {
    marginBottom: 20,
    textAlign: 'center'
  },
  title: {
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 5,
    textAlign: 'center'
  },
  reference: {
    fontSize: 10,
    marginBottom: 3,
    textAlign: 'left'
  },
  section: {
    marginBottom: 15
  },
  row: {
    flexDirection: 'row',
    marginBottom: 5,
    alignItems: 'flex-start'
  },
  label: {
    width: '50%',
    fontWeight: 'bold'
  },
  value: {
    width: '50%'
  },
  declaration: {
    marginTop: 30,
    textAlign: 'justify',
    marginBottom: 20
  },
  signature: {
    marginTop: 40,
    textAlign: 'right',
    marginRight: 100
  },
  line: {
    borderBottomWidth: 1,
    borderBottomColor: '#000',
    marginTop: 2,
    width: 200,
    marginLeft: 'auto'
  }
});

const Padtalni = ({ result }) => {
      const toMarathiDigits = str => str.replace(/\d/g, d => '०१२३४५६७८९'[d]);
const retirement = toMarathiDigits(result.dateOfRetirement);
const dateOfAppointment = toMarathiDigits(result.dateOfAppointment);
  
  return(

    <View size="A4" style={styles.page}>
      {/* Header Section */}
      <View style={styles.header}>
        <Text style={styles.title}>सेवा पडताळणी प्रमाणपत्र</Text>
        <Text style={styles.reference}>
          संदर्भ :-१. शासन निर्णय वित्त विभाग के. पीईएन-१०८८/११६७/सेवा-४ दि.५.५१९९०
        </Text>
        <Text style={styles.reference}>
          २. मा. शिक्षण संचालक, उच्च शिक्षण, म. रा. पुणे यांचे पत्र क. उशिसं/सेवा पडताळणी/२०१२/ लेखा-१/२०३७७ दिनांक ७.२.२०१३
        </Text>
      </View>

      {/* Employee Details Section */}
      <View style={styles.section}>
        <View style={styles.row}>
          <Text style={styles.label}>१) शिक्षक / शिक्षकेत्तर कर्मचाऱ्याचे नाव</Text>
          <Text style={styles.value}>: {result.employeeNameMar}</Text>
        </View>
        <View style={styles.row}>
          <Text style={styles.label}>२) पदनाम (सेवानिवृत्तीच्या वेळी)</Text>
          <Text style={styles.value}>: {result.designationMar}</Text>
        </View>
        <View style={styles.row}>
          <Text style={styles.label}>३) प्रथम नियुक्ती दिनांक</Text>
          <Text style={styles.value}>: 01/10/2005</Text>
        </View>
        <View style={styles.row}>
          <Text style={styles.label}>४) सेवानिवृत्त दिनांक</Text>
          <Text style={styles.value}>: {retirement}</Text>
        </View>
        <View style={styles.row}>
          <Text style={styles.label}>५) सेवानिवृत्तीचा प्रकार</Text>
          <Text style={styles.value}>: नियत वयोमानानुसार</Text>
        </View>
        <View style={styles.row}>
          <Text style={styles.label}>६) सेवानिवृत्तीच्या वेळचा वेतनस्तर</Text>
          <Text style={styles.value}>: {result.payLevel}</Text>
        </View>
        <View style={styles.row}>
          <Text style={styles.label}>७) वेतन स्तर मधील मुळ वेतन</Text>
          <Text style={styles.value}>: 95300</Text>
        </View>
        <View style={styles.row}>
          <Text style={styles.label}>८) अतिप्रदान वेतन वसूली</Text>
          <Text style={styles.value}>: नाही</Text>
        </View>
        <View style={styles.row}>
          <Text style={styles.label}>९) न्यायालयीन प्रकरण/विभागीय चौकशी /इतर</Text>
          <Text style={styles.value}>: नाही</Text>
        </View>
        <View style={styles.row}>
          <Text style={styles.label}>१०) दि. ({dateOfAppointment} ते {retirement}) या कालावधीत</Text>
          <Text style={styles.value}>शासन अनुदानित पदावर काम केलेले आहे.</Text>
        </View>
      </View>

      {/* Declaration Section */}
      <View style={styles.declaration}>
        <Text>
          प्रमाणित करण्यात येते की, संबंधित कर्मचाऱ्यांची माहिती बरोबर आहे, तसेच या कार्यालयाची कोणतीही वसूली प्रस्तावीत / प्रलंबीत नाही.
        </Text>
      </View>

      {/* Signature Section */}
      <View style={styles.signature}>
        <Text>प्राचार्य</Text>

      </View>
      
      <View style={[styles.signature, {marginTop: 70}]}>
        <Text>लेखाधिकारी</Text>

      </View>
    </View>
);
};
export default Padtalni;